const Dashboard = (props) => {
    return <div>Dashboard</div>
}

export default Dashboard;